// permission.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private instanceId = Math.random();
    private userPermissions: string[] = [];
    private permissionsSubject = new BehaviorSubject<string[]>([]);
    public permissions$ = this.permissionsSubject.asObservable();
    constructor() {
        // 监听 localStorage 变化（用于 iframe 同步）
        window.addEventListener('storage', (event) => {
            if (event.key === 'userPermissions') {
                this.loadFromStorage();
            }
        });

        this.loadFromStorage();
    }
    private loadFromStorage() {
        const savedPermissions = localStorage.getItem('userPermissions');
        if (savedPermissions) {
            this.userPermissions = JSON.parse(savedPermissions);
            this.permissionsSubject.next(this.userPermissions);
        }
    }

    setPermissions(permissions: string[]) {
        this.userPermissions = permissions;
        this.permissionsSubject.next(permissions);
        // 保存到本地存储，防止刷新后丢失
        localStorage.setItem('userPermissions', JSON.stringify(permissions));
    }

    hasPermission(permission: string): boolean {
        return this.userPermissions.includes(permission);
    }

    getPermissions(): string[] {
        return [...this.userPermissions];
    }

    // 清空权限（退出登录时使用）
    clearPermissions() {
        this.userPermissions = [];
        this.permissionsSubject.next([]);
        localStorage.removeItem('userPermissions');
    }
}